import { EditPartitionFeature } from "features";
import RootPage from "../RootPage";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import localisations from "../../shell/localisation";
import { reactPlugin } from "../../app-insights";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams } from "react-router-dom";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

function EditPartitionPage() {
    const { id } = useParams<{ id: string }>();

    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.editPartition.heading}>
            <EditPartitionFeature fieldCompanyId={fieldCompanyId} partitionId={id} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, EditPartitionPage, "Edit Partition Page");
